import { Component, Inject, OnInit, TemplateRef, Type } from '@angular/core';
import { ModalRef } from '@rensa/shared/classes/modal-ref';
import { ConfirmModalOptions } from '@rensa/shared/interfaces/confirm-modal-options';
import { ModalButton } from '@rensa/shared/interfaces/modal-button';
import { MODAL_DATA_INJECTION_TOKEN } from '@rensa/shared/modal-data-injection-token';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
    contentType: 'template' | 'string' | 'component';
    content: string | TemplateRef<any> | Type<any>;
    context: { close: Function };
    title!: string;
    buttons!: ModalButton[];
    isDangerous!: boolean;

    constructor(
        private modalRef: ModalRef,
        @Inject(MODAL_DATA_INJECTION_TOKEN) private setData: (data) => void
    ) { }

    ngOnInit(): void {
        this.title = this.modalRef.options.title;
        this.buttons = this.modalRef.options.buttons;
        this.isDangerous = (this.modalRef.options as ConfirmModalOptions)?.type === 'danger';
        this.content = this.modalRef.content;

        if (typeof this.content === 'string') {
            this.contentType = 'string';
        } else if (this.content instanceof TemplateRef) {
            this.contentType = 'template';
            this.context = {
                close: this.modalRef.dismiss.bind(this.modalRef),
            };
        } else {
            this.contentType = 'component';
        }
    }

    close(): void {
        this.modalRef.dismiss('close');
    }

    onModalButtonClick(button: ModalButton): void {
        this.modalRef.dismiss(button.dismissType);
    }
}
